import styled from 'styled-components';

export const Link = styled.a`
  width: 100%;
`;
